import { ChatCommandEvent, RoomAction } from '../constants/enums'
import { MfcChatCard } from '../libraries/mfc/MfcChatCard'
import { FCTYPE_CMESG } from '../mfcLogic/mfcConstants'
import { resolveChannel } from '../mfcLogic/userProperties'
import { pubSubChatCommands } from '../state/pubSub'
import { loadUserIfNeeded } from './loadUserIfNeeded'
import { roomAction } from './workerActions'

export const sendRoomMessage = async (id: number, message = '') => {
    if (message.trim().length === 0) {
        return
    }

    const user = await loadUserIfNeeded(id)
    const { streamType } = user
    const channel = resolveChannel(id, streamType)

    if (message.startsWith('/')) {
        const payload = { message, user, chatType: FCTYPE_CMESG }
        pubSubChatCommands.emit(ChatCommandEvent.GENERATE_COMMANDS, payload)
    } else {
        const mfcChatCard = new MfcChatCard({
            callback_func: (oCard) => {
                const sJSON = JSON.stringify({
                    to: channel,
                    type: 'card',
                    data_enc: oCard.data_enc,
                    data_tkx: oCard.data_tkx,
                })
                roomAction(RoomAction.SEND_XMESG, { id, sJSON })
            },
        })
        // this will create the chat card and send the socket message if needed
        mfcChatCard.ProcessChatInput(message)
        roomAction(RoomAction.SEND_MESSAGE, { id, message })
    }
}
